import authHeader from "../../../../authentication/authservices/auth-header";
import apiClient from "../../../../http-common";

export const getHandoverSummaryDetails = async (admissionId, userId) => {
  return await apiClient.get(
    `/clinicalCareChart/isbarRetrieve/${admissionId}/${userId}`,{
              headers: authHeader(),
            }
  );
};

export const getHandoverSummaryDetailsMorning = async (admissionId, userId) => {
  return await apiClient.get(
    `/clinicalCareChart/isbarRetrieveMorning/${admissionId}/${userId}`,{
              headers: authHeader(),
            }
  );
};

export const saveHandoverSummary = async (obj) => {
  return await apiClient?.post(
    `/clinicalCareChart/saveIsbarHandover`,
    obj,{
              headers: authHeader(),
            }
  );
};

export const acceptHandoverSummary = async (obj) => {
  return await apiClient?.post(
    `/clinicalCareChart/acceptIsbarHandover`,
    obj,{
              headers: authHeader(),
            }
  );
};

// export const getHandoverSummaryFullData = async (admisssionId) => {
//   return await apiClient.get(
//     `/clinicalCareChart/getIsbarHandoverList/${admisssionId}`,
//   );
// };
export const getHandoverSummaryFullData = async (obj) => {
  return await apiClient.post(
    `/clinicalCareChart/getIsbarHandoverList`,
    obj,{
              headers: authHeader(),
            }
  );
};
export const getHandoverEmp = async (Obj) => {
  return await apiClient?.post(
    `/isbarNursesHandover/dropdownEmployeeforIsbarWeb`,
    Obj,{
              headers: authHeader(),
            }
  );
};

// export const getHandoverOldList = async (admissionId) => {
//   return await apiClient?.get(
//     `/isbarNursesHandover/getListNurseshandOver/${admissionId}`,
//   );
// };

export const getHandoverOldList = async (admissionId) => {
  return await apiClient?.get(
    `/isbarNursesHandover/getListHandOver/${admissionId}`,{
              headers: authHeader(),
            }
  );
};